module.exports = __webpack_public_path__ + "img/logo-old.3c7fe684.svg";